import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { environment } from 'src/environments/environment';

@Injectable({ providedIn: 'root' })
export class SharedService {
	withCredentials = { withCredentials: true };

	constructor(private http: HttpClient) { }

	// System Routes
	deleteVideoFile(url: string, activity_type: string) {
		const options = { params: { activity_type: activity_type }, withCredentials: true };
		return this.http.delete<any>(environment.api + url, options);
	}

	reanalyze(url: string, activity_type: string) {
		const options = { params: { activity_type: activity_type }, withCredentials: true };
		return this.http.patch<any>(environment.api + url, { reanalyze: true, status: 'ANALYZING' }, options);
	}

	getEntity(url: string, activity_type: string) {
		const options = { params: { activity_type: activity_type }, withCredentials: true };
		return this.http.get<any>(environment.api + url, options);
	}

	// Elbit chat-bot
	initialChatBotElbit(url: string) {
		return this.http.get<any>(environment.api + url);
	}

	chatBotAnswerElbit(url: string, data: any) {
		return this.http.post<any>(environment.api + url, data);
	}

	resetChatBotElbit(url: string) {
		return this.http.delete<any>(environment.api + url);
	}
	//end of elbit chat-bot

	// Chat LLM VERTEX AI
	initialChatVertexAI(url: string) {
		return this.http.get<any>(environment.api + url, this.withCredentials);
	}

	chatWithVertexAI(url: string, data: any) {
		return this.http.post<any>(environment.api + url, data, this.withCredentials);
	}

	endChatWithVertexAI(url: string) {
		return this.http.delete<any>(environment.api + url, this.withCredentials);
	}

	// Report Generation
	generateReport(url: string, data: any, activity_type: string) {
		const options = { params: { activity_type: activity_type }, withCredentials: true };
		return this.http.post<any>(environment.api + url, data, options);
	}

	getReport(url: string, data: any, activity_type: string) {
		const options = { params: { activity_type: activity_type }, withCredentials: true };
		return this.http.post<any>(environment.api + url, data, options);
	}

	deleteReport(url: string, activity_type: string) {
		const options = { params: { activity_type: activity_type }, withCredentials: true };
		return this.http.delete<any>(environment.api + url, options);
	}

	// Extra Functions
	getSmoothedRGBResults(url: string, data: any) {
		return this.http.post<any>(environment.api + url, data);
	}
}